import * as io from 'io-ts';

export const any = io.union([io.undefined, io.void, io.null, io.unknown, io.UnknownArray, io.UnknownRecord]);
